import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Field } from 'src/app/models_new/classes/field';
import { FieldType } from 'src/app/models_new/types/field-type';
import { FormBuilder, Validators } from '@angular/forms';
import { SimulationType } from 'src/app/services/api/comment-api.service';
import { ICommentActionEvent } from 'src/app/models_new/types/comment';
import {
  LocalStorageService,
  StorageMethod,
} from 'src/app/services/local-storage.service';
import { LocalStorageKey } from 'src/app/models_new/enums/local-storage-keys';

@Component({
  selector: 'app-comment-reply',
  templateUrl: './comment-reply.component.html',
  styleUrls: ['./comment-reply.component.scss'],
})
export class CommentReplyComponent implements OnInit {
  private publicUserMetadata: ICommentActionEvent['comment_reply']['public_user'];
  reply: Field;
  publicUsername: Field;
  publicOrgnName: Field;

  @Input() enableCancel?: boolean = true;
  @Input() accessMode: SimulationType;
  @Input() inputComment?: string;
  @Output() replied?: EventEmitter<ICommentActionEvent['comment_reply']> =
    new EventEmitter();
  @Output() cancel?: EventEmitter<boolean> = new EventEmitter();

  constructor(
    public formBuilder: FormBuilder,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.publicUserMetadata = this.localStorageService.getData(
      LocalStorageKey.PUBLIC_COMMENT_METADATA
    );
    this.inputComment
      ? this.setCommentFields('Edit comment', this.inputComment)
      : this.setCommentFields('Add a comment');
  }

  public doAction(actionId: string): void {
    if (actionId === 'post') {
      if (this.accessMode !== SimulationType.PRIVATE) {
        const userMetadata: ICommentActionEvent['comment_reply']['public_user'] =
          {
            name: this.publicUsername.formControl.value,
            organization: this.publicOrgnName.formControl.value,
          };
        this.replied.emit({
          comment: this.reply.formControl.value,
          public_user: userMetadata,
        });
        this.localStorageService.setData(
          LocalStorageKey.PUBLIC_COMMENT_METADATA,
          (this.publicUserMetadata = userMetadata),
          StorageMethod.LOCAL
        );
        this.setCommentFields('Add a comment');
      } else {
        this.replied.emit({ comment: this.reply.formControl.value });
        this.setCommentFields('Add a comment');
      }
    }
    if (actionId === 'cancel') {
      this.cancel.emit(true);
    }
  }

  private setCommentFields(label: string, defaultValue?: string): void {
    this.reply = new Field(
      FieldType.TEXT,
      true,
      defaultValue || '',
      [Validators.required],
      null,
      null,
      null,
      { name: 'reply', label: label },
      'reply'
    );
    if (this.accessMode !== SimulationType.PRIVATE) {
      this.publicUsername = new Field(
        FieldType.TEXT,
        true,
        this.publicUserMetadata?.name || '',
        [Validators.required],
        null,
        null,
        null,
        { name: 'username', label: 'Full name' },
        'username'
      );
      this.publicOrgnName = new Field(
        FieldType.TEXT,
        true,
        this.publicUserMetadata?.organization || '',
        [Validators.required],
        null,
        null,
        null,
        { name: 'organization', label: 'Organization' },
        'organization'
      );
    }
  }

  public canProceed(): boolean {
    if (
      this.accessMode === SimulationType.PRIVATE &&
      this.reply.formControl.value
    )
      return true;
    else if (
      this.accessMode !== SimulationType.PRIVATE &&
      this.reply.formControl.value &&
      this.publicOrgnName.formControl.value &&
      this.publicUsername.formControl.value
    )
      return true;
    else {
      return false;
    }
  }
}
